import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpEvent } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

import { Observable } from 'rxjs';

import { Category } from '../model/category';
import { PollAnswer } from '../model/pollAnswer';
import { Question } from '../model/question';

import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';


@Injectable()
export class APIService {

    protected basePath = environment.basePath;
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string,
        @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Adds the poll answer
     * @param body PollAnswer Object that needs to be added
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public answerPost(body: PollAnswer, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public answerPost(body: PollAnswer, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public answerPost(body: PollAnswer, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public answerPost(body: PollAnswer, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling answerPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/answer`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe: 'response',
                reportProgress
            },
        );
    }

    /**
     * Returns a list of categories.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public categoriesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Category>>;
    public categoriesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Category>>>;
    public categoriesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Category>>>;
    public categoriesGet(observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Category>>(`${this.basePath}/categories`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

    /**
     * Gets a list of Question and its Options by category
     * @param categoryId ID of category to get questions
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public categoryCategoryIdQuestionsGet(categoryId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<Question>>;
    public categoryCategoryIdQuestionsGet(categoryId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Question>>>;
    public categoryCategoryIdQuestionsGet(categoryId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Question>>>;
    public categoryCategoryIdQuestionsGet(categoryId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (categoryId === null || categoryId === undefined) {
            throw new Error('Required parameter categoryId was null or undefined when calling categoryCategoryIdQuestionsGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Question>>(`${this.basePath}/category/${encodeURIComponent(String(categoryId))}/questions`,
            {
                withCredentials: this.configuration.withCredentials,
                headers,
                observe,
                reportProgress
            }
        );
    }

}
